import { PatentAssignment } from "./patent-assignement";
export default PatentAssignment;
